<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    password: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      $value: `${this.value ? this.value : ''}`,
      $autofilled: false,
    };
  },
  mounted() {
    this.$el.addEventListener('animationstart', ({ animationName }) => {
      if (animationName === this.$style.onAutoFillStart) {
        this.$data.$autofilled = true;
        if (!this.$el.value) this.$emit('input', '--autofilled--');
      }
      if (animationName === this.$style.onAutoFillCancel) {
        this.$data.$autofilled = false;
      }
    }, false);

    // IE autofill fix
    setTimeout(() => {
      const inputVal = this.$el.value;
      const defineVal = this.$data.$value;
      if (!defineVal && !!inputVal) {
        this.$data.$value = inputVal;
      }
    }, 120);
  },
  watch: {
    value() {
      this.$data.$value = `${this.value ? this.value : ''}`;
    },
    '$data.$value': function input(value) {
      this.$emit('input', value);
    },
  },
  methods: {
    update() {
      this.$data.$value = this.$el.value;
    },
  },
};
</script>

<template lang="pug">
input(
  :type="password ? 'password' : 'text'",
  @input="update()",
  @change="update()",
  :class="[$style.input, error && $style.error]",
  :disabled="disabled",
  :maxlength="maxlength")
</template>

<style module lang="sass">
.input
  display: block
  padding: 0
  border: 0
  box-sizing: border-box
  outline: none
  height: $s_inp_height
  font-size: $s_inp_font
  font-weight: $s_inp_font_weight
  background: #fff
  color: $s_inp_font_color
  border-top: 0px solid #fff
  border-bottom: 1px solid $s_inp_border
  transition: border-color $a_speed, border-width $a_speed, color $a_speed
  caret-color: $s_color_main
  &:not(:disabled):hover
    border-top-width: 1px
    border-bottom: 2px solid $s_inp_border_hover

  &:not(:disabled):focus
    border-top-width: 1px
    border-bottom: 2px solid $s_color_main

  &:-webkit-autofill
    background-color: #fff
    -webkit-box-shadow: 0 0 0 $s_inp_height #fff inset
    -webkit-text-fill-color: #795548 !important

  &:disabled
    border-top-width: 0px
    border-bottom-style: dashed
    cursor: not-allowed
    color: $s_inp_text_disabled
    &:-webkit-autofill
      -webkit-text-fill-color: $s_inp_text_disabled !important

  .error.input
    border-top-width: 1px
    border-bottom: 2px solid $s_inp_error_color

@keyframes onAutoFillStart
  from
    background-color: #fff

  to
    background-color: #fff

@keyframes onAutoFillCancel
  from
    background-color: #fff

  to
    background-color: #fff

input:-webkit-autofill
  background-color: #fff

input:-webkit-autofill
  animation-name: onAutoFillStart

input:not(:-webkit-autofill)
  animation-name: onAutoFillCancel

</style>
